// utils/AddToBasketService.ts

/**
 * Updates the AddToBasket popup with the provided response data.
 * @param {object} response - The response object containing updated basket details.
 * @param {string} response.title - The title to display in the popup.
 * @param {string} response.totalForAddedQty - The total price for the added quantity.
 * @param {string} response.prodImageUrl - The URL of the product image.
 * @param {string} response.addedQty - The quantity of the product added.
 * @param {string} response.productName - The name of the product added.
 */
export function updateAddToBasketPopup(response: {
	title: string;
	totalForAddedQty: string;
	prodImageUrl: string;
	addedQty: string;
	productName: string;
}): void {
	const atbWrapper = document.getElementById('add-to-basket-popup-wrapper');
	const prefix = 'add-to-basket-';

	if (!atbWrapper) {
		console.error('AddToBasket popup wrapper not found.');
		return;
	}

	const elements = {
		title: document.getElementById(`${prefix}title`),
		totalForAddedQty: document.getElementById(`${prefix}totalforaddedqty`),
		prodImageUrl: document.getElementById(`${prefix}prodimageurl`) as HTMLImageElement,
		addedQty: document.getElementById(`${prefix}addedqty`),
		productName: document.getElementById(`${prefix}productname`),
	};

	elements.title ? (elements.title.innerHTML = response.title) : '';
	//elements.totalForAddedQty.innerHTML = response.totalForAddedQty;
	elements.prodImageUrl ? (elements.prodImageUrl.src = response.prodImageUrl) : '';
	elements.addedQty ? (elements.addedQty.innerHTML = response.addedQty) : '';
	elements.productName ? (elements.productName.innerHTML = response.productName) : '';

	atbWrapper.classList.add('active');

	closeAddToBasketPopup();
}

/**
 * Handles the logic to close the AddToBasket popup after a delay or on specific user interaction.
 */
function closeAddToBasketPopup(): void {
	const atbPopUp = document.getElementById('add-to-basket-popup');
	const atbWrapper = document.getElementById('add-to-basket-popup-wrapper');

	if (!atbPopUp || !atbWrapper) {
		console.error('AddToBasket popup or wrapper not found.');
		return;
	}

	setTimeout(() => {
		if (!atbPopUp.classList.contains('hovering')) {
			atbWrapper.classList.remove('active');
		} else {
			closeAddToBasketPopup();
		}
	}, 4000);
}
